export default __webpack_public_path__ + "static/media/icon-contact-email@2x.bda8779f.svg";